module.exports = __webpack_public_path__ + "static/media/Youtube.2d3a6ef0.svg";